import { render } from "./SteamBanner.vue?vue&type=template&id=4258bc96"
const script = {}

import exportComponent from "/home/runner/work/stc-frontend/stc-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__